import { useState } from "react";
import {
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  makeStyles,
  Collapse,
} from "@material-ui/core";
import { Link, useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandLess from "@material-ui/icons/ExpandLess";
import ExpandMore from "@material-ui/icons/ExpandMore";

const useStyles = makeStyles((theme) => ({
  drawerPaper: {
    width: 260,
  },
  listItem: {
    borderLeft: "3px solid transparent",
  },
  listItemActive: {
    borderLeft: "3px solid #1976d2",
    backgroundColor: "#e3f2fd",
  },
  link: {
    textDecoration: "none",
    color: "#1976d2",
    fontSize: "16px",
    display: "block",
    width: "100%",
  },
  linkActive: {
    fontWeight: "bold",
  },
  productItem: {
    cursor: "pointer",
    color: "#1976d2",
    fontSize: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  productItemActive: {
    fontWeight: "bold",
  },
  subItem: {
    paddingLeft: theme.spacing(4),
    borderLeft: "3px solid transparent",
  },
  subItemActive: {
    borderLeft: "3px solid #1976d2",
    backgroundColor: "#e3f2fd",
  },
  subLink: {
    textDecoration: "none",
    color: "#555",
    fontSize: "15px",
    display: "block",
    width: "100%",
  },
  subLinkActive: {
    color: "#1976d2",
    fontWeight: "bold",
  },
  icon: {
    color: "white",
  },
}));

function DrawerComponent() {
  const classes = useStyles();
  const [openDrawer, setOpenDrawer] = useState(false);
  const [productOpen, setProductOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const isProductActive = ["/realestate", "/hotelBooking"].includes(location.pathname);

  const closeDrawer = () => {
    setOpenDrawer(false);
    setProductOpen(false);
  };

  const handleProductClick = () => {
    setProductOpen((prev) => !prev);
  };

  const goTo = (path) => {
    closeDrawer();
    navigate(path);
  };

  return (
    <>
      <Drawer
        open={openDrawer}
        onClose={closeDrawer}
        classes={{ paper: classes.drawerPaper }}
      >
        <List>
          <ListItem
            button
            onClick={closeDrawer}
            className={`${classes.listItem} ${location.pathname === "/" ? classes.listItemActive : ""}`}
          >
            <ListItemText>
              <Link
                to="/"
                className={`${classes.link} ${location.pathname === "/" ? classes.linkActive : ""}`}
              >
                Home
              </Link>
            </ListItemText>
          </ListItem>
          <Divider />

          <ListItem
            button
            onClick={handleProductClick}
            className={`${classes.listItem} ${isProductActive ? classes.listItemActive : ""}`}
          >
            <ListItemText>
              <span className={`${classes.productItem} ${isProductActive ? classes.productItemActive : ""}`}>
                Product
                {productOpen ? <ExpandLess /> : <ExpandMore />}
              </span>
            </ListItemText>
          </ListItem>
          <Collapse in={productOpen} timeout="auto" unmountOnExit>
            <List disablePadding>
              <ListItem
                button
                onClick={() => goTo("/realestate")}
                className={`${classes.subItem} ${location.pathname === "/realestate" ? classes.subItemActive : ""}`}
              >
                <ListItemText>
                  <span className={`${classes.subLink} ${location.pathname === "/realestate" ? classes.subLinkActive : ""}`}>
                    Real estate
                  </span>
                </ListItemText>
              </ListItem>
              <ListItem
                button
                onClick={() => goTo("/hotelBooking")}
                className={`${classes.subItem} ${location.pathname === "/hotelBooking" ? classes.subItemActive : ""}`}
              >
                <ListItemText>
                  <span className={`${classes.subLink} ${location.pathname === "/hotelBooking" ? classes.subLinkActive : ""}`}>
                    Hotel Booking
                  </span>
                </ListItemText>
              </ListItem>
            </List>
          </Collapse>
          <Divider />

          <ListItem
            button
            onClick={closeDrawer}
            className={`${classes.listItem} ${location.pathname === "/about" ? classes.listItemActive : ""}`}
          >
            <ListItemText>
              <Link
                to="/about"
                className={`${classes.link} ${location.pathname === "/about" ? classes.linkActive : ""}`}
              >
                About
              </Link>
            </ListItemText>
          </ListItem>
          <Divider />

          <ListItem
            button
            onClick={closeDrawer}
            className={`${classes.listItem} ${location.pathname === "/contact" ? classes.listItemActive : ""}`}
          >
            <ListItemText>
              <Link
                to="/contact"
                className={`${classes.link} ${location.pathname === "/contact" ? classes.linkActive : ""}`}
              >
                Contact
              </Link>
            </ListItemText>
          </ListItem>
          <Divider />
        </List>
      </Drawer>

      <IconButton onClick={() => setOpenDrawer(!openDrawer)} className={classes.icon}>
        <MenuIcon />
      </IconButton>
    </>
  );
}
export default DrawerComponent;
